var map = {
	"./en.ts": [
		26763
	],
	"./es.ts": [
		32120,
		120
	],
	"./zh-CHS.ts": [
		9635,
		635
	],
	"./zh-TW.ts": [
		82754,
		754
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 23950;
module.exports = webpackAsyncContext;